import { render, staticRenderFns } from "./SalaryCheckFitterTable.vue?vue&type=template&id=46956a01&scoped=true"
import script from "./SalaryCheckFitterTable.vue?vue&type=script&lang=js"
export * from "./SalaryCheckFitterTable.vue?vue&type=script&lang=js"
import style0 from "./SalaryCheckFitterTable.vue?vue&type=style&index=0&id=46956a01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46956a01",
  null
  
)

export default component.exports